import React from 'react';
import cn from 'classnames';
import {
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsSectionRow,
  SettingToggle,
} from '@views/Settings/components';
import styles from './PublicProfile.module.scss';
import { URLInput } from '@components/FormInputs';
import { usePublicProfileUrlEditor } from '@support/hooks/use-public-profile-url-editor';

export default function PublicProfile() {
  const {
    value,
    enabled,
    saving,
    isChanged,
    errorMsg,
    inputRef,
    handleInputChange,
    handleInputKeyDown,
    toggleEnabled,
    saveChanges,
  } = usePublicProfileUrlEditor();

  const disableUrl = saving || !enabled;

  return (
    <>
      <Section>
        <SettingsSectionLabel>Public Profile</SettingsSectionLabel>
        <SettingsSectionBox className={styles.padBottom}>
          <SettingsSectionRow>
            <SettingToggle
              disabled={saving}
              title="Enable Public Profile"
              checked={enabled}
              name="public_profile_enabled"
              onChange={toggleEnabled}
            />
          </SettingsSectionRow>
          <p>
            Enable your public profile and share it with anyone inside and outside of Clay.{' '}
            <a href="https://go.clay.earth/edit-profile" target="_blank">
              Learn more.
            </a>
          </p>
        </SettingsSectionBox>
      </Section>

      <Section className={cn(disableUrl && styles.disabledSection)}>
        <SettingsSectionLabel>Profile URL</SettingsSectionLabel>
        <SettingsSectionBox className={styles.inputWrapper}>
          <URLInput
            precedeText="clay.earth/profile/"
            value={value}
            hasError={!!errorMsg}
            onKeyDown={handleInputKeyDown}
            disabled={disableUrl}
            isChanged={isChanged}
            isSaving={saving}
            inputRef={inputRef}
            copyLink
            openLink
            onSaveClick={saveChanges}
            onChange={handleInputChange}
            urlBuilder={(input) => `https://clay.earth/profile/${input}`}
          />
        </SettingsSectionBox>
        {errorMsg ? (
          <div className={styles.errorText}>{errorMsg}</div>
        ) : (
          <div className={styles.infoText}>
            Set a custom URL for your public profile.{' '}
            <a href="https://go.clay.earth/edit-profile" target="_blank">
              Learn more.
            </a>
          </div>
        )}
      </Section>
    </>
  );
}
